
/* eslint no-underscore-dangle:  0 */
/* eslint-disable no-debugger, no-console */
/* eslint-disable */
import React from 'react';
import './loader.css';
const Loader = () => {
    return (
        <div className="loader">
            
        </div>
    );
};

export default Loader;